import React, { useState, useEffect } from "react";

import axios from "../../../axios/index";
import { Link } from "react-router-dom";

// styles
import ModalStyles from "../../Dashboard/DashboardReuseAbleComponents/Modal.module.css";
import Dstyles from "../UserFilesDetail/UserFilesDetail.module.css";

// components
import Modal from "react-bootstrap/Modal";

export default function LandingModal(props) {
  return (
    <>
      <style type="text/css">
        {`
                .modal {
                    background: #393939;
                }

                .modal-content {
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }

                .modal-dialog-centered {
                    justify-content: center !important;
                }

                @media only screen and (min-width: 768.98px) {
                    .modal-content {
                        width: 942px;
                    }
                }

                @media only screen and (max-width: 768.98px) {
                    .modal-content {
                    width: calc(100% - 1.5rem) !important;
                    }
                }

            `}
      </style>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton dir="rtl" style={{ border: "none" }}>
          <div className="w-100 d-flex align-items-start justify-content-between px-2">
            <div className={ModalStyles.title}>مشاهده روی نقشه</div>
          </div>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div
            className="w-100 d-flex flex-column align-items-center justify-content-center p-0"
            style={{ background: "#FFFFFF" }}
          >
            {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
            <iframe
              src="https://360.fenercioglu.com.tr/"
              className="w-100"
              style={{
                height: "550px",
              }}
              allowFullScreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
